import { $api } from "../generated/client";
import type {
	DateFilterCondition,
	DateFilterValue,
	StringFilterCondition,
	StringFilterValue,
} from "./use-return-requests";

type UseCountFilteredReturnRequestsParams = {
	shopId: string;
	filters: {
		status?: {
			condition: StringFilterCondition;
			value: StringFilterValue;
		};
		reason?: {
			condition: StringFilterCondition;
			value: StringFilterValue;
		};
		assignee?: {
			condition: StringFilterCondition;
			value: StringFilterValue;
		};
		createdDate?: {
			condition: DateFilterCondition;
			value: DateFilterValue;
		};
		resolution?: {
			condition: StringFilterCondition;
			value: StringFilterValue;
		};
		returnStore?: {
			condition: StringFilterCondition;
			value: StringFilterValue;
		};
	};
	quickFilter?:
		| "toBeTreated"
		| "toBeValidated"
		| "shippingTooLong"
		| "carrierError"
		| "carrierIssues";
};

export default function useCountFilteredReturnRequests({
	shopId,
	filters,
	quickFilter,
}: UseCountFilteredReturnRequestsParams) {
	return $api.useQuery("get", "/shops/{shopId}/return-requests/count", {
		params: {
			path: { shopId },
			query: {
				quickFilter,
				statusCondition: filters?.status?.condition,
				statusValue: filters?.status?.value,
				reasonCondition: filters?.reason?.condition,
				reasonValue: filters?.reason?.value,
				assigneeCondition: filters?.assignee?.condition,
				assigneeValue: filters?.assignee?.value,
				createdDateCondition: filters?.createdDate?.condition,
				createdDateValue: filters?.createdDate?.value,
				resolutionCondition: filters?.resolution?.condition,
				resolutionValue: filters?.resolution?.value,
				returnStoreCondition: filters?.returnStore?.condition,
				returnStoreValue: filters?.returnStore?.value,
			},
		},
	});
}
